const getClientTimeZone = (): string | null => {
  try {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return null;
  }
};

export default getClientTimeZone;
